module.exports = __webpack_public_path__ + "static/media/resume.9238cff9.pdf";